import { useTheme } from "@emotion/react";
import React from "react";

const CcLoader = () => {
  const theme = useTheme();

  const loaderWrapperStyle = {
    display: "block",
    position: "relative",
    width: 80,
    height: 80,
    margin: "10px auto",
    div: {
      position: "absolute",
      width: 6,
      height: 6,
      background: theme.colors.primary,
      borderRadius: "50%",
      animation: "spiner 1.2s linear infinite",
      "&:nth-of-type(1) ": {
        animationDelay: "0s",
        top: 37,
        left: 66,
      },
      "&:nth-of-type(2) ":{
        animationDelay: "-0.1s",
        top: 22,
        left: 62,
      },
      "&:nth-of-type(3) ":{
        animationDelay: "-0.2s",
        top: 11,
        left: 52,
      },
      "&:nth-of-type(4) ":{
        animationDelay: "-0.3s",
        top: 7,
        left: 37,
      },
      "&:nth-of-type(5) ":{
        animationDelay: "-0.4s",
        top: 11,
        left: 22,
      },
      "&:nth-of-type(6) ":{
        animationDelay: "-0.5s",
        top: 22,
        left: 11,
      },
      "&:nth-of-type(7) ":{
        animationDelay: "-0.6s",
        top: 37,
        left: 7,
      },
      "&:nth-of-type(8) ":{
        animationDelay: "-0.7s",
        top: 52,
        left: 11,
      },
      "&:nth-of-type(9) ":{
        animationDelay: "-0.8s",
        top: 62,
        left: 22,
      },
      "&:nth-of-type(10)": {
        animationDelay: "-0.9s",
        top: 66,
        left: 37,
      },
      "&:nth-of-type(11)": {
        animationDelay: "-1s",
        top: 62,
        left: 52,
      },
      "&:nth-of-type(12)": {
        animationDelay: "-1.1s",
        top: 52,
        left: 62,
      },
      "@keyframes spiner": {
        "0%, 20%, 80%, 100%": {
          transform: "scale(1)",
        },
        "50%": {
          transform: "scale(1.5)",
        },
      },
    },
  };

  return (
    <div css={loaderWrapperStyle}>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  )
};

export default CcLoader;
